import { render, staticRenderFns } from "./distributionReport.vue?vue&type=template&id=747bc5a4&scoped=true"
import script from "./distributionReport.vue?vue&type=script&lang=js"
export * from "./distributionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747bc5a4",
  null
  
)

export default component.exports